import { getApiBaseUrl } from '../config/apiBase';
import localStorageService from '../services/localStorage';

export function getMacroscopicImage(folder) {
  if (!folder?.meta) return null;

  if (Array.isArray(folder.meta.registrationData)) {
    const macroscopicImage = folder.meta.registrationData.find(
      (item) => item.type === 'macroscopic image'
    );
    if (macroscopicImage) return macroscopicImage;
  }

  const imgStackDict = folder.meta.imgStackDict;
  const macroscopicImages = imgStackDict?.['Macroscopic Images']?.['Macroscopic Images'];
  if (macroscopicImages?.length > 0) {
    return macroscopicImages[0];
  }

  return null;
}

export function createDZITileSource(image, frame = 0) {
  const imageId = image.yamlId || image._id;
  if (!imageId) return null;

  const urlSearchParams = new URLSearchParams();
  // OpenSeadragon copies every query param from the .dzi URL onto each tile JPG.
  // frame=0 is the Girder default — omit it so tiles load as plain .../level/x_y.jpg.
  // Non-zero frames (z-stack) must stay on the .dzi URL and propagate to tiles.
  if (frame !== 0) {
    urlSearchParams.append('frame', frame);
  }
  const token = localStorageService.getToken();
  if (token) {
    urlSearchParams.append('token', token);
  }

  const query = urlSearchParams.toString();
  const base = `${getApiBaseUrl()}/item/${imageId}/tiles/dzi.dzi`;
  return query ? `${base}?${query}` : base;
}

export function getImageItemId(image) {
  return image?.yamlId || image?._id || image?.itemid || null;
}
